<template lang="pug">
.side-nav-container
	.side-nav-toggle(@click='toggleNavState' :class='navState')
		span
		span
		span
	aside.sidenav(:class='navState')
		.drawer-controls
			img(src='/img/fid-logo.png' height='40')
			.controls
				a.download-app(:href='downloadLinkByOs' download)
					i.icon.icon-download-app(v-if='!isElectronApp')
				i.icon.icon-bell(@click='checkNotifications')
					span.notification-count(
						v-if='emailNotifications.notificationCount && emailNotifications.notificationCount > 0'
					) {{ emailNotifications.notificationCount }}
					span.notification-count.error(
						v-else-if='!emailNotifications.notificationCount && emailNotifications.notificationCount !== 0'
						@mouseenter='setErrorHovered( true )'
					) !
						.error-pop-up(
							:class='{ "active" : errorHovered }'
							@mouseenter='clearHideTimeout'
							@mouseleave='setHideTimeout'
						)
							p Could not retrieve your emails. Please wait and try again. If this problem persists please contact support.
				.square.icon-arrow(@click='toggleNavState')

		.drawer-header

			.user-image
				.icon-person

			h2.display-name(:title='displayName') {{ displayName }}

			.user-controls
				button.sign-out(
					@click='logout'
				) Sign out
				span &nbsp;•&nbsp;
				button.settings(
					:class='{ "active" : isSettingsOpen }'
					@click='toggleNotificationCenter'
				) Settings

			.notification-container(:class='{ "active" : isSettingsOpen }')
				.slider-container
					.button-slider(
						:class='notificationLoadingState'
						@click='changeNotificationStatus'
					)
						.button-circle(:class='buttonStatus')

					p.notification-title Email Notifications

				.drive-link-container
					short-text-input.drive-link-input(
						:options='driveLinkTextOptions'
						:value='usersDriveLink'
						@input='usersDriveLink = $event'
					)

					.drive-link-status-container(:class='[showDriveLinkStatus, driveLinkStatus ]')
						.bubble
						.status {{ driveLinkStatusText }}
		nav
			ul
				router-link(
					v-for='( link, i ) in navigation'
					:key='i'
					tag='li'
					:to='link.to'
					:class='{ active : subMenuActive( link.subLinks ), "has-sub-menu" : link.subLinks }'
				)
					.flex
						.icon-wrapper
							i.icon(:class='`icon-${link.icon}`')
						span {{ link.title }}
					ul.sub-menu(
						v-if='link.subLinks'
					)
						router-link(
							v-for='subLink in link.subLinks'
							:key='subLink.title'
							tag='li'
							:to='subLink.to'
							@click.native='closeIfMobile'
						)
							span {{ subLink.title }}

</template>

<script>
import isElectron from 'is-electron';
// eslint-disable-next-line no-unused-vars
import { editUser, userNotifications, GDriveLinkUpdate } from '@/lib/API';
// eslint-disable-next-line no-unused-vars
import { GetFirestoreUser } from '@/lib/db/users';
// eslint-disable-next-line no-unused-vars
import { RemoveEndSlashes } from '@/lib/utils';

export default {
	data : () => ( {
		navState : ( window.innerWidth > 640 ) ? 'open' : 'collapsed',

		navigation : [
			{
				icon  : 'home',
				title : 'Home',
				to    : 'home',
			},
			{
				icon  : 'people',
				title : 'Manager Users',
				to    : 'users',
			},
			{
				icon  : 'paper',
				title : 'Reports',
				to    : 'reports',
			},
			// {
			// 	icon  : 'map',
			// 	title : 'Map',
			// 	to    : 'map'
			// },
			{
				icon     : 'radar',
				title    : 'Engineering',
				to       : 'agreements',
				subLinks : [
					{
						title : 'Agreements',
						to    : 'agreements'
					},
					{
						title : 'Developer & Utility Reviews',
						to    : 'developer-utility-reviews'
					},
					{
						title : 'Engineering Action Requests',
						to    : 'engineering-action-requests'
					},
					{
						title : 'Facility Information',
						to    : 'canals'
					},
					{
						title : 'Job References',
						to    : 'jobs'
					},
					{
						title : 'Parcel Look-up',
						to    : 'parcels'
					},
					{
						title : 'Permits',
						to    : 'permits'
					},
					// {
					// 	title : 'Test',
					// 	to    : 'test'
					// }
				]
			}
		],

		isSettingsOpen           : false,
		notificationLoadingState : 'init', // data management state
		buttonStatus             : 'off', // visibility management state for BUTTON CIRCLE

		userNotificationStatus : false,
		emailNotifications     : {},

		usersDriveLink      : null,
		saveDriveLinkStatus : 'idle',

		driveLinkTimeout         : null,
		driveLinkTimeoutDuration : 1000,

		errorHovered : false,
		hideTimeout  : null,
	} ),

	watch : {

		navState : {
			immediate : true,
			handler( state ) {
				this.$store.dispatch( 'setNavState', state );
			}
		},

		user : {
			immediate : true,
			handler( user ) {

				if ( user && user.uid ) {
					this.setEmailNotifications();
					this.userNotificationStatus = user.notificationsStatus;

					if ( this.userNotificationStatus ) {
						this.notificationLoadingState = 'passed';
						this.buttonStatus = 'on';
					}

					this.usersDriveLink = user.driveLink;
				}

			},
		},

		usersDriveLink : {
			handler( val, lastVal ) {
				// console.log( `val: ${val}\nlastVal: ${lastVal}\n` );

				if ( !lastVal && this.user.driveLink ) {
					return;
				}

				this.saveDriveLinkStatus = 'idle';

				// no user, nothing we can modify
				// no value, we can't add it
				if ( !this.user || !val ) {
					// console.log( '( !this.user || !val ) === true' );
					// console.log( this.user );
					// console.log( `val: ${val}\n` );
					return;
				}

				if ( this.driveLinkTimeout ) {
					window.clearTimeout( this.driveLinkTimeout );
				}

				// first we'll have to structure the new user model
				// (just change the driveLink property)

				const newUser = { data : {} };
				newUser.data.driveLink = val;

				// then we'll have to set a timeout so that whenever
				// a user is done typing the request will be sent to
				// the API thus effecting their user node.

				// at the beginning of our timeout we're going to set
				// our status indicator to "saving". We will then call
				// the API to edit the user. Depending on the response
				// from the API we will change our status indicator to
				// either "passed" or "failed"

				this.driveLinkTimeout = window.setTimeout( () => {

					// const regexForEndSlashes = /([\\/]+)$/;

					// if ( val.match( regexForEndSlashes ) ) { // This will remove trailing slashes, then trigger this watcher to run again
					// 	this.usersDriveLink = RemoveEndSlashes( val );
					// 	return;
					// }

					this.saveDriveLinkStatus = 'saving';
					// console.log( 'Submit user edit' );
					// console.log( newUser );
					// console.log( `this.user.usersKey: ${this.postgresUser.usersKey}` );

					const payload = {
						email     : this.postgresUser.email,
						driveLink : this.usersDriveLink
					};

					GDriveLinkUpdate( payload )
						.then( () => {
							// console.log( 'saved user edits' );
							this.saveDriveLinkStatus = 'passed';
							// console.log( this.saveDriveLinkStatus );
							// console.log( this.driveLinkStatusText );
							window.setTimeout( () => {
								this.saveDriveLinkStatus = 'valid';
							}, 3000 );
						} )
						.catch( ( e ) => {
							// console.log( 'Could not save user edits' );
							console.error( e );
							this.saveDriveLinkStatus = 'failed';
						} );

				}, this.driveLinkTimeoutDuration );
			}
		},

	},

	computed : {

		showDriveLinkStatus() {
			const status = this.driveLinkStatus;

			if ( status === 'passed' || status === 'failed' || status === 'invalid' ) {
				return 'open';
			}

			return 'hidden';
		},

		driveLinkStatusText() {
			const statusToText = {
				'idle'    : null,
				'passed'  : 'Saved',
				'failed'  : 'Failed',
				'saving'  : 'Saving...',
				'invalid' : 'Invalid G Drive'
			};

			return statusToText[this.driveLinkStatus];
		},

		driveLinkTextOptions() {
			return {
				placeholder   : 'e.g. G://',
				minimalLabel  : 'G Drive File Path',
				selectOnFocus : true,
			};
		},

		downloadLinkByOs() {

			const userAgent = navigator.userAgent.toLowerCase();

			if ( userAgent.includes( 'win' ) ) {
				return '/fid-access-replacement.exe';
			}

			return null;

		},

		isElectronApp() {
			return isElectron();
		},

		user() {
			return this.$store.state.user;
		},
		postgresUser() {
			return this.$store.getters.postgresUser;
		},
		displayName() {
			const { name, email } = this.postgresUser;

			if ( !email ) {
				return '';
			}

			if ( !name ) {
				return email.split( '@' )[0];
			}

			return name;
		},

		submenuLinkActive() {
			const engineeringLinks = [
				'agreements',
				'engineering-action-requests',
				'canals',
				'jobs',
				'developer-utility-reviews',
				'permits',
				'parcels',
			];
			return engineeringLinks.includes( this.$route.name );
		},

		driveLinkState() { // Determines
			return this.$store.state.driveLinkState;
		},

		driveLinkStatus() {
			const { saveDriveLinkStatus, driveLinkState } = this;

			if ( saveDriveLinkStatus === 'saving' ) {
				return saveDriveLinkStatus;
			}

			if ( driveLinkState === 'invalid' ) {
				return driveLinkState;
			}

			return saveDriveLinkStatus;
		}
	},

	methods : {

		checkNotifications() {
			this.$router.replace( '/' );
		},

		setHideTimeout() {
			this.hideTimeout = window.setTimeout( () => {
				this.errorHovered = false;
			}, 500 );
		},

		clearHideTimeout() {
			if ( this.hideTimeout ) {
				window.clearTimeout( this.hideTimeout );
			}
		},

		setErrorHovered( status ) {

			this.errorHovered = status;

		},

		logout() {
			this.$store.dispatch( 'logout' );

			return this.$router.push( '/login' );
		},

		setEmailNotifications() {

			const { user } = this;

			if ( user && user.uid ) {

				const {
					notificationCount,
					notificationsStatus,
				} = user;

				this.emailNotifications = {
					notificationCount,
					notificationsStatus
				};

			}

		},

		toggleNotificationCenter() {
			this.isSettingsOpen = !this.isSettingsOpen;
		},

		changeNotificationStatus() {

			this.notificationLoadingState = 'loading';

			userNotifications( !this.userNotificationStatus, this.$store.getters.postgresUser.usersKey )
				.then( ( status ) => {

					if ( status.user.notificationsStatus ) {
						this.notificationLoadingState = 'passed';
						this.buttonStatus             = 'on';
					}

					else {
						this.notificationLoadingState = 'init';
						this.buttonStatus             = 'off';
					}

					this.userNotificationStatus = status.user.notificationsStatus;

				} )
				.catch( ( e ) => {
					console.error( e );
					this.notificationLoadingState = 'failed';

					window.setTimeout( () => {
						this.notificationLoadingState = 'idle';
					}, 3000 );
				} );

		},

		toggleNavState() {
			if ( this.navState === 'open' ) {
				this.navState = 'collapsed';
			}
			else if ( this.navState === 'collapsed' ) {
				this.navState = 'open';
			}
		},

		subMenuActive( links ) {
			// if there's no links, the answer
			// is obviously false.
			if ( !links ) {
				return false;
			}

			// try to find index of currently active
			// path in the links
			const { path }          = this.$route;
			const indexOfActiveLink = links.findIndex( a => a.to === path );

			return indexOfActiveLink !== -1;
		},

		closeIfMobile() {
			if ( window.innerWidth < 641 ) {
				this.navState = 'collapsed';
			}
		}
	},

	components : {
		ShortTextInput : () => import( '@/components/form-inputs/ShortTextInput' ),
	},
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

aside.sidenav {
	background: linear-gradient(270deg, rgba(228, 248, 224, 0.4) 0%, rgba(247, 253, 246, 0.2) 55%, rgba(255, 255, 255, 0) 100%), #FFFFFF;
	width: 300px;
	height: 100vh;
	overflow-y: auto;
	overflow-x: hidden;
	transition: width 0.2s ease-out;
	flex-shrink: 0;
	z-index: 100;
	position: relative;

	&.collapsed {
		width: 80px;
		overflow: hidden;
		transition: width 0.2s ease-out;

		.drawer-controls {
			position: relative;

			.controls {
				justify-content: flex-start;
				position: absolute;
				top: 0;
				right: 0;
			}

			img, .icon {
				opacity: 0;
				transition: opacity 0.2s ease-out;
			}

			.icon-arrow {
				transform: rotate(180deg);
			}
		}

		.drawer-header {
			opacity: 0;
			transform: scale(1, 0);
			transform-origin: top;
			transition: transform 0.2s ease-in-out, opacity 0.1s ease-out;
		}

		nav {
			margin-top: -100px;
			transition: margin 0.2s ease-out;

			span {
				display: none;
			}

			i.icon::before {
				margin-right: 0 !important;
			}

			.sub-menu {
				opacity: 0;
				transform: scale(1, 0);
				transform-origin: top;
				transition: transform 0.2s ease-in-out, opacity 0.1s ease-out;
			}
		}
	}

	.download-app {
		margin: auto 16px auto auto;
		display: flex;
	}

	i.icon {
		cursor: pointer;
		position: relative;
		z-index: 1;

		&::before {
			font-size: 36px;
			color: $color-primary;
		}

		&.icon-download-app {
			pointer-events: none;

			a {
				cursor: pointer;
				pointer-events: all;
			}
		}

		&.icon-bell {
			margin-right: 16px;

			.notification-count {
				position: absolute;
				top: 5px;
				right: 2px;
				transform: translate( 50%, -50% );
				background: $color-primary;
				border-radius: 50%;
				color: white;
				font-family: 'Poppins', sans-serif;
				font-size: 12px;
				padding: 10px;
				border: 2px solid white;
				height: 0;
				width: 0;
				display: flex;
				flex-flow: row;
				align-items: center;
				justify-content: center;
				z-index: 2;

				&.error {
					background: $error;

					.error-pop-up {
						background: $lightGrey;
						border-radius: 15px;
						box-shadow: $inputBoxShadow;
						padding: 15px;
						width: 150px;
						font-size: 12px;
						color: $input-color;
						top: 80%;
						right: 80%;
						position: absolute;
						transform: translate( 50%, -25px );
						opacity: 0;
						pointer-events: none;
						transition: opacity .2s ease-in, transform .2s ease-in;

						&::before {
							content: '';
							position: absolute;
							height: 0;
							width: 0;
							overflow: hidden;
							top: 0;
							left: 50%;
							transform: translate( 0%, -100% );
							border-top: 6px solid transparent;
							border-left: 6px solid transparent;
							border-right: 6px solid transparent;
							border-bottom: 6px solid #E9EEF3;
						}

						&.active {
							transform: translate( 50%, 0 );
							opacity: 1;
							pointer-events: all;
						}
					}
				}
			}
		}
	}

	nav {
		margin-top: 0;
		transition: margin 0.2s ease-out;
		margin: 0 20px;

		ul {
			margin: 0;
			padding: 0;
		}

		.router-link-active, .active {
			color: $color-primary;

			> span,
			&:not(.has-sub-menu) .flex > span {
				color: $color-primary;
			}

			.sub-menu li::before {
				background: $color-primary;
			}
		}

		li {
			font-size: 15px;
			font-weight: 600;
			color: $input-color;
			padding: 13px 0;
			list-style-type: none;

			.flex {
				display: flex;
				align-items: center;

				.icon-wrapper {
					display: flex;
					justify-content: center;
					width: 36px;
					margin-right: 10px;

					.icon-radar::before {
						font-size: 20px;
					}
				}
			}

			i.icon::before {
				font-size: 24px;
				color: inherit;
			}
		}

		li:hover {
			cursor: pointer;
		}

		ul.sub-menu {
			margin-top: 13px;
			transform: scale(1, 1);
			transform-origin: top;
			transition: opacity 0.1s ease-out 0.1s, transform 0.2s ease-out;

			li {
				padding: 6px 0;
				font-size: 13px;
				position: relative;
				margin-left: 21px + 24px;

				&::before {
					content: '';
					height: calc(100% + 2px);
					width: 3px;
					position: absolute;
					left: -29px;
					width: 3px;
					background: $input-color;
					border-radius: 2px;
					top: 50%;
					transform: translateY(-50%);
				}

				&.router-link-exact-active::after {
					content: '';
					height: 6px;
					width: 6px;
					border: 3px solid $color-primary;
					border-radius: 50% 50%;
					background: white;
					position: absolute;
					left: -29px;
					top: 50%;
					transform: translate(calc(-50% + 1.5px), -50%);
				}
			}
		}
	}

	.drawer-controls {
		display: flex;
		justify-content: space-between;
		margin: 20px 20px 0 20px;

		.controls {
			display: flex;
			align-items: center;
		}

		img, .icon {
			opacity: 1;
			transition: opacity 0.2s ease-out;
		}

		// TODO: remove this and replace with actual icons
		.square {
			height: 40px;
			width: 40px;
			border: 3px solid $color-primary;
			border-radius: 5px;
			cursor: pointer;
		}
	}

	.drawer-header {
		text-align: center;
		transform: scale(1, 1);
		opacity: 1;
		transform-origin: top;
		transition: opacity 0.1s ease-out 0.1s, transform 0.2s ease-out;

		.user-image {
			height: 64px;
			width: 64px;
			background: $color-primary;
			border-radius: 50% 50%;
			margin: 25px auto 0 auto;
			display: flex;
			align-items: center;
			justify-content: center;

			.icon-person {
				font-size: 48px;

				&::before {
					color: white;
				}
			}
		}

		h2.display-name {
			font-weight: 400;
			line-height: normal;
			font-size: 22px;
			letter-spacing: 0.03em;
			color: $color-primary;
			overflow: hidden;
			text-overflow: ellipsis;
			text-transform: capitalize;
			white-space: nowrap;
			width: 100%;
			text-align: center;
			margin-top: 15px;
		}

		.user-controls {
			display: flex;
			justify-content: center;
			color: $input-color;
			margin-bottom: 10px;

			button {
				background: 0;
				outline: 0;
				border: 0;
				padding: 0;
				cursor: pointer;
				font-size: 14px;
				font-weight: 300;
				letter-spacing: 0.03em;
				color: $input-color;
				border-bottom: 1px dashed transparent;

				&:hover {
					border-bottom: 1px dashed $color-primary;
				}

				&.settings {
					position: relative;

					&.active {

						&::before {
							content: '';
							height: 0;
							width: 0;
							position: absolute;
							bottom: -11px;
							left: 50%;
							transform: translate( -100%, -0% );
							overflow: hidden;
							border-top: 6px solid transparent;
							border-left: 6px solid transparent;
							border-right: 6px solid transparent;
							border-bottom: 6px solid #E9EEF3;
						}
					}
				}
			}
		}

		.notification-container {
			display: flex;
			flex-flow: column;
			align-items: center;
			width: 100%;
			background: #E9EEF3;
			padding: 0;
			height: 0;
			opacity: 0;
			overflow: hidden;
			transition: height .2s ease-in, padding .2s ease-in, .2s opacity ease-in;

			&.active {
				height: initial;
				opacity: 1;
			}

			.slider-container {
				width: 100%;
				display: flex;
				flex-flow: row nowrap;
				align-items: center;
				justify-content: left;
				padding: 15px;

				.button-slider {
					height: 20px;
					width: 40px;
					border-radius: 10px;
					background: $alternateGrey;
					cursor: pointer;
					transition: background 0.2s ease;

					&.loading {
						background: rgba( $alternateGrey, .6 );
					}

					&.failed {
						background: $error;
					}

					&.passed {
						background: $color-primary;
					}

					.button-circle {
						background: white;
						height: 16px;
						width: 16px;
						border-radius: 50%;
						box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.25);
						top: 50%;
						transform: translateY( -50% );
						margin-left: 2px;
						overflow: hidden;
						position: relative;

						&.on {
							animation: slideOn .2s 1 forwards;
						}

						&.off {
							animation: slideOff .2s 1 forwards;
						}
					}
				}

				.notification-title {
					margin-left: 15px;
					font-size: 16px;
					color: $color-primary;
				}
			}

			.drive-link-container {
				background: linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.30866) 40.14%, rgba(255, 255, 255, 0) 100%);
				width: 100%;
				position: relative;
				overflow: hidden;

				.drive-link-input {
					background: transparent;
					box-shadow: none;

					input {

						&::placeholder {
							color: $input-color-more-faded;
						}
					}
				}

				.drive-link-status-container {
					position: absolute;
					right: 20px;
					top: 0;
					transform: translateY( -100% );
					transition: transform .2s ease-in-out;

					&:not( .idle ) {
						transform: translateY( 0 );
					}

					&.failed {

						.bubble {
							background: $red;
						}

						.status {
							color: $red;
						}
					}

					&.passed {

						.bubble {
							background: $color-primary;
						}

						.status {
							color: $color-primary;
						}
					}

					&.invalid {
						transform: translateY( 0 );
						.bubble {
							background: $red;
						}

						.status {
							color: $red;
						}
					}

					.bubble {
						border-radius: 0 0 15px 15px;
						padding: 0 15px;
						width: 100%;
						height: 10px;
					}

					.status {
						position: relative;
						font-size: 12px;
						color: $input-color;
					}
				}
			}
		}
	}
}

@keyframes slideOn {
	from {
		left: 0;
		transform: translateY( -50% );
	}

	to {
		left: 90%;
		transform: translate( -100%, -50% );
	}
}

@keyframes slideOff {
	from {
		left: 90%;
		transform: translate( -100%, -50% );
	}

	to {
		left: 0;
		transform: translateY( -50% );
	}
}

@media only screen and ( max-width: 640px ) {

	aside.sidenav {
		position: fixed;
		width: 100vw !important;
		left: 0;
		transform: translate3d(0,0,0);
		transition: transform 0.2s ease !important;

		&.collapsed {
			transform: translate3d(-100vw, 0, 0);
		}

		.drawer-header {
			display: flex;
			flex-direction: column;
			align-items: flex-end;

			.user-image {
				margin: 0 30px 0 30px !important;
			}

			> *:not(.notification-container) {
				margin-left: 30px;
				margin-right: 30px;
			}

			h2.display-name {
				text-align: right !important;
			}
		}

		nav {
			margin-top: 15px !important;

			ul li {
				font-size: 24px;

				.flex {
					flex-flow: row-reverse;

					.icon-wrapper {
						margin-right: 0;
						margin-left: 10px;
					}
				}

				ul.sub-menu {
					padding-bottom: 150px;

					li {
						font-size: 18px;
						margin-left: 0;
						margin-right: 45px;
						text-align: right;

						&::before {
							left: unset;
							right: -29px;
						}

						&::after {
							left: unset !important;
							right: -29px;
							transform: translate(calc(50% - 1.5px), -50%) !important;
						}
					}
				}
			}
		}
	}

	.controls,
	nav > ul > li:not(.has-sub-menu) {
		display: none !important;
	}

	.side-nav-toggle {
		position: fixed;
		right: 15px;
		bottom: 65px;
		height: 60px;
		width: 60px;
		background: $color-primary;
		z-index: 101;
		border-radius: 50%;
		box-shadow: $defaultBoxShadow;

		span {
			position: absolute;
			height: 4px;
			width: 24px;
			border-radius: 2px;
			background: white;
			top: 50%;
			left: 50%;
			transition: opacity 0.2s ease, transform 0.2s ease;

			&:nth-child(1) {
				transform: translate(-50%, calc(-50% - 10px));
			}

			&:nth-child(2) {
				transform: translate(-50%, -50%);
				width: 30px;
			}

			&:nth-child(3) {
				transform: translate(-50%, calc(-50% + 10px));
			}
		}

		&.open {

			span {

				&:nth-child(2) {
					opacity: 0;
				}

				&:nth-child(1) {
					transform: translate(-50%,-50%) rotate(45deg);
				}

				&:nth-child(3) {
					transform: translate(-50%,-50%) rotate(-45deg);
				}
			}
		}
	}
}
</style>
